module.exports = __webpack_public_path__ + "img/pause.de881dd8.svg";